import {
	hideLoadingScreen,
	router,
	setPageContent,
	showLoadingScreen,
} from "..";
import { putPassword } from "../api/password";
import { sendVerificationCode } from "../api/send-verification-code";
import { locale } from "../locale";
import { Bulma } from "../view/bulma";
import {
	centeredBox,
	errorToast,
	passwordInput,
	successToast,
} from "../view/components";

function resetPasswordPage() {
	const email = Bulma.input({
		type: "email",
	});

	const verificationCode = Bulma.input({
		type: "text",
	});

	const password = passwordInput();

	function onClickSendVerificationCode() {
		showLoadingScreen();
		sendVerificationCode(email.getValue())
			.then(successToast)
			.finally(hideLoadingScreen);
	}

	function onClickSave() {
		showLoadingScreen();
		putPassword(
			email.getValue(),
			password.getValue(),
			verificationCode.getValue(),
		)
			.then(() => router.jump("/sign-in"))
			.catch(errorToast)
			.finally(hideLoadingScreen);
	}

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(locale.strings.resetPassword),
			document.createElement("hr"),

			Bulma.title(
				locale.string({
					enGB: "Step 1: Request a verification code. If you cannot find the code in your inbox, please check your spam folder. Requesting a new verification code will invalidate any previously issued codes.",
					deDE: "Schritt 1: Fordern Sie einen Verifizierungscode an. Wenn Sie den Code nicht in Ihrem Posteingang finden, überprüfen Sie bitte Ihren Spam-Ordner. Wenn Sie einen neuen Verifizierungscode anfordern, werden alle zuvor ausgestellten Codes ungültig.",
					frFR: "Étape 1 : Demander un code de vérification. Si vous ne trouvez pas le code dans votre boîte de réception, vérifiez votre dossier de courrier indésirable. La demande d'un nouveau code de vérification invalidera tous les codes précédemment émis.",
					svSE: "Steg 1: Begär en verifieringskod. Om du inte hittar koden i din inkorg, kontrollera din skräppostmapp. Om du begär en ny verifieringskod kommer alla tidigare utfärdade koder att ogiltigförklaras.",
				}),
				"is-6",
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.email),
				Bulma.control({}, email.element),
			),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickSendVerificationCode,
						styles: ["is-primary"],
					},
					locale.string({
						enGB: "Send verification code",
						deDE: "Bestätigungscode senden",
						frFR: "Envoyer le code de vérification",
						svSE: "Skicka verifieringskod",
					}),
				),
			),
			document.createElement("hr"),

			Bulma.title(
				locale.string({
					enGB: "Step 2: Enter the verification code and choose a new password.",
					deDE: "Schritt 2: Geben Sie den Bestätigungscode ein und wählen Sie ein neues Passwort.",
					frFR: "Étape 2 : Saisissez le code de vérification et choisissez un nouveau mot de passe.",
					svSE: "Steg 2: Ange verifieringskoden och välj ett nytt lösenord.",
				}),
				"is-6",
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.verificationCode),
				Bulma.control({}, verificationCode.element),
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.password),
				password.element,
			),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickSave,
						styles: ["is-primary"],
					},
					locale.strings.save,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/sign-in"),
						styles: ["is-primary"],
					},
					locale.strings.cancel,
				),
			),
		),
	);
}

export { resetPasswordPage };
